import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox, Message } from 'semantic-ui-react';
import { SheetDatanew } from '../../../services/auth-service/authService'
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService1';
import DynamicForm from '../common/DynamicForm';
import { AgGridReact } from 'ag-grid-react';
import Select, { components } from "react-select";
import { render } from "@testing-library/react";
import Modal from 'react-bootstrap/Modal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { GetProcessNames, SaveRelationship, CreateData } from '../../../services/process/process_data/process_data';
import './relationship.css';


// Constants
const IDENTIFIER = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },
];

const DATABASE_OPTIONS = [
  { value: "mysql", label: "Mysql" }
];

const WIDTH_OPTIONS = [
  { value: "xs", label: "Extra Small" },
  { value: "s", label: "Small" },
  { value: "m", label: "Medium" },
  { value: "l", label: "Large" },
  { value: "xl", label: "Extra Large" }
];

const DATE_FORMAT_OPTIONS = [
  { value: "MM/DD/YYYY", label: "MM/DD/YYYY" },
  { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
  { value: "YYYY-MM-DD", label: "YYYY-MM-DD" }
];

const DATE_TYPE_OPTIONS = [
  { value: "day", label: "Day" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" }
];

const INPUT_FIELD_OPTIONS = [
  { value: "decimal", label: "Decimal" },
  { value: "integer", label: "Integer" },
  { value: "text", label: "Text" },
  { value: "date", label: "Date" },
];

const FUNCTION_OPTIONS_DATA = [
  'Input Field',
  'Dropdown',
  'Dropdown with Multiselect',
  'Data Displayer',
  'Data Displayer with reference',
  'Date Field',
  'File Upload',
  'File Displayer',
  'Table Header'
];


const ValueContainer = ({ children, getValue, ...props }) => {
  const maxToShow = 1;
  const length = getValue().length;
  const displayChips = React.Children.toArray(children).slice(0, maxToShow);
  const shouldBadgeShow = length > maxToShow;
  const displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* Optional badge display */}
      </div>
    </components.ValueContainer>
  );
};


const Headerconfig = () => {
  // Form state
  const [configName, setConfigName] = useState('');
  const [description, setDescription] = useState('');
  const [headerid, setHeaderid] = useState('');
  const [database, setDatabase] = useState('');
  
  // Options state
  const [databaseNames, setDatabaseOptions] = useState([]);
  const [tableNames, setTableOptions] = useState([]);
  const [functionNames, setFunctionOptions] = useState([]);
  const [headerNames, setHeaderOptions] = useState([]);
  const [selectedprocess1, setSelectedprocess1] = useState([]);
  
  // Rows state
  const [rows, setRows] = useState([{
    id: 1,
    index: 1,
    schema: null,
    table: null,
    header: null,
    function: null,
    customOptions: {},
    headerOptions: [],
    tableOptions1: [],
    renameChecked: false,
    renameValue: '',
    width: null,
    isMandatory: false
  }]);
  
  // Selection state
  const [selectedSchema, setSelectedSchema] = useState('');
  const [selectedTable, setSelectedTable] = useState('');
  
  // User and data state
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fields, setFields] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [filterconditions, setFilterconditions] = useState([]);
  
  // UI state
  const [renamePopupOpen, setRenamePopupOpen] = useState(false);
  const [currentRenameIndex, setCurrentRenameIndex] = useState(null);
  const [tempRenameValue, setTempRenameValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Utility functions
  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
      return (shouldBeShown(value) ? { display: 'none' } : { ...base });
    }
  };

  const showSuccessMessage = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 5000);
  };

  const showErrorMessage = (message) => {
    setErrorMessage(message);
    setTimeout(() => setErrorMessage(''), 5000);
  };

  // Event handlers
  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  const handleSelectChange = (event, { value }) => {
    fetchDatabaseInfo();
    setDatabase(event);
  };

  const handleSelectChange1 = (event, { value }) => {
    fetchTableData(event);
    setSelectedSchema(event);
  };

  const handleSelectChange2 = (event, { value }) => {
    fetchHeaderData(event);
    setSelectedTable(event);
  };

  const handleUpdate = async () => {
    try {
      setIsSaving(true);
      console.log('formData', headerid);
      
      const sanitizedRows = rows.map(({ headerOptions, tableOptions1, ...rest }) => rest);
      const payload = {
        schema_name: 'process_data',
        table: 'header_config',
        set_column: [
          { 'headerconfig_name': configName },
          { 'headerconfig_description': description },
          { 'header_details_json': sanitizedRows }
        ],
        'where': [{ "headerconfig_id": headerid }]
      };

      const FileUploadCredentials = Fetchupdatequery();

      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Update response:", response);
      showSuccessMessage('Configuration updated successfully!');
      setEditMode(false);
      
      // Reload after a brief delay to show success message
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error updating data:", error);
      showErrorMessage("Error updating configuration: " + (error.message || "Unknown error"));
    } finally {
      setIsSaving(false);
    }
  };

  const handleEditClick = (row) => {
    console.log("Editing row:", row, row.headerconfig_id);
    setEditMode(true);
    fetchEditInfo(row.headerconfig_id);
  };

  const handleDeleteRow = (indexToDelete) => {
    const updated = rows.filter((_, index) => index !== indexToDelete);
    // reassign indexes to maintain sequential order
    const reindexed = updated.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRows(reindexed);
  };

  // Allow user to explicitly change the order/index of a row
  const handleIndexChange = (rowIndex, value) => {
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return;
    const updatedRows = [...rows];
    updatedRows[rowIndex].index = parsed;
    // sort the array according to the new index values
    updatedRows.sort((a, b) => (a.index || 0) - (b.index || 0));
    // resequence to avoid duplicate indexes and keep them consecutive
    const reindexed = updatedRows.map((r, i) => ({ ...r, index: i + 1 }));
    setRows(reindexed);
  };

  // Programmatically move a row up or down in the list
  const moveRow = (from, to) => {
    if (to < 0 || to >= rows.length) return;
    const updatedRows = [...rows];
    const [moved] = updatedRows.splice(from, 1);
    updatedRows.splice(to, 0, moved);
    // update index values to reflect new sequence
    const reindexed = updatedRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRows(reindexed);
  };

  // Handler for drag end event from react-beautiful-dnd
  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index) return;
    
    const newRows = Array.from(rows);
    const [reorderedRow] = newRows.splice(source.index, 1);
    newRows.splice(destination.index, 0, reorderedRow);
    
    // resequence indexes
    const reindexed = newRows.map((row, idx) => ({ ...row, index: idx + 1 }));
    setRows(reindexed);
  };

  const handleCustomOptionChange = (index, field, value) => {
    const updatedRows = [...rows];
    const updatedCustomOptions = { ...updatedRows[index].customOptions };

    updatedCustomOptions[field] = value;
    updatedRows[index].customOptions = updatedCustomOptions;
    
    console.log(index, field, value, updatedRows);
    setRows(updatedRows);
  };

  const handleCreate = async () => {
    try {
      setIsSaving(true);
      
      const sanitizedRows = rows.map(({ headerOptions, tableOptions1, ...rest }) => rest);
      const payload = {
        'database': 'process_data',
        'table': 'header_config',
        formData: {
          'headerconfig_name': configName,
          'headerconfig_description': description,
          'header_details_json': sanitizedRows
        }
      };
      
      console.log('payload', payload);
      const FileUploadCredentials = CreateData();

      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Create Response:", response);
      showSuccessMessage('Configuration created successfully!');
      
      // Reload after a brief delay to show success message
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error in POST request:", error);
      showErrorMessage("Error creating configuration: " + (error.message || "Unknown error"));
    } finally {
      setIsSaving(false);
    }
  };

  const fetchTableData = async (database) => {
    try {
      const payload = {
        query: `show tables from ${database.label}`
      };
      
      console.log('payload---', database.label);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Table data response:", response);
      const data = response["data"];
      
      const dropdownOptions = data.map(item => ({
        value: item[`Tables_in_${database.label}`],
        label: item[`Tables_in_${database.label}`]
      }));
      
      console.log(dropdownOptions);
      setTableOptions(dropdownOptions);
    } catch (error) {
      console.error("Error in database request:", error);
      showErrorMessage("Error fetching table data");
    }
  };

  const fetchTableInfo = async () => {
    try {
      const payload = {
        headerconfig_id: 1,
        filterconditions: filterconditions
      };

      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = {
        fields: [
          { columnName: 'headerconfig_id' },
          { columnName: 'headerconfig_name' },
          { columnName: 'headerconfig_description' }
        ]
      };
      
      console.log("data", data);
      
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true,
        }));
        
        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      showErrorMessage("Error fetching fields data");
    } finally {
      setLoading(false);
    }
  };

  const fetchTableData1 = async (database, index) => {
    try {
      const payload = {
        query: `show tables from ${database.label}`
      };
      
      console.log('payload---', database.label);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Table data response:", response);
      const data = response["data"];
      
      const dropdownOptions = data.map(item => ({
        value: item[`Tables_in_${database.label}`],
        label: item[`Tables_in_${database.label}`]
      }));
      
      console.log(dropdownOptions);

      const updatedRows = [...rows];
      updatedRows[index].tableOptions1 = dropdownOptions;
      setRows(updatedRows);
    } catch (error) {
      console.error("Error in database request:", error);
      showErrorMessage("Error fetching table data");
    }
  };

  const fetchFunctionOptions = () => {
    const dropdownOptions = FUNCTION_OPTIONS_DATA.map(item => ({
      value: item,
      label: item
    }));
    
    console.log(dropdownOptions);
    setFunctionOptions(dropdownOptions);
  };

  const fetchHeaderData = async (table) => {
    try {
      console.log('payload---', table, database);
      
      const payload = {
        query: `desc ${selectedSchema.value}.${table.label}`
      };
      
      console.log('payload---', table.label, database);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Header data response:", response);
      const data = response["data"];
      
      const dropdownOptions = data.map(item => ({
        value: item.Field,
        label: item.Field
      }));
      
      console.log(dropdownOptions);
      setHeaderOptions(dropdownOptions);
    } catch (error) {
      console.error("Error in header request:", error);
      showErrorMessage("Error fetching header data");
    }
  };

  const fetchHeaderData1 = async (table, schema, index) => {
    try {
      console.log('payload---', table, schema);
      
      const payload = {
        query: `desc ${schema.value}.${table.value}`
      };
      
      console.log('payload---', table.value, schema.value);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Header data response:", response);
      const data = response["data"];
      
      const dropdownOptions = data.map(item => ({
        value: item.Field,
        label: item.Field
      }));
      
      console.log(dropdownOptions);
      
      const updatedRows = [...rows];
      updatedRows[index].headerOptions = dropdownOptions;
      setRows(updatedRows);
    } catch (error) {
      console.error("Error in header request:", error);
      showErrorMessage("Error fetching header data");
    }
  };

  const fetchProcessNames = async () => {
    try {
      const payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
      };

      const FileUploadCredentials = GetProcessNames();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Process names response:", response);
      const table_data = response.data;

      const names = table_data.map((data) => ({
        value: data.process_id,
        label: data.process_name
      }));
      
      setSelectedprocess1(names);
    } catch (error) {
      console.error("Error fetching process names:", error);
      showErrorMessage("Error fetching process names");
    }
  };

  const fetchDatabaseInfo = async () => {
    try {
      const payload = {
        query: `show databases`
      };
      
      console.log('payload---', payload);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Database info response:", response);
      const data = response["data"];
      
      const dropdownOptions = data.map(item => ({
        value: item.Database,
        label: item.Database
      }));
      
      console.log(dropdownOptions);
      setDatabaseOptions(dropdownOptions);
    } catch (error) {
      console.error("Error in database request:", error);
      showErrorMessage("Error fetching database info");
    }
  };

  const handleOpenRenamePopup = (index) => {
    setCurrentRenameIndex(index);
    setTempRenameValue(rows[index].renameValue || '');
    setRenamePopupOpen(true);
  };

  const fetchAllHeaderConfigs = async () => {
    try {
      const payload = {
        query: `Select * from process_data.header_config;`
      };
      
      console.log('payload---', payload);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      console.log("Header configs response:", response);
      const data = response["data"];
      
      console.log(data);
      
      if (data && data.length > 0) {
        setRowData(data);
      }
    } catch (error) {
      console.error("Error in database request:", error);
      showErrorMessage("Error fetching header configurations");
    }
  };

  const fetchEditInfo = async (id) => {
    try {
      const payload = {
        query: `Select * from process_data.header_config where headerconfig_id = '${id}';`
      };
      
      console.log('payload---', payload);

      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response["data"];
      console.log(data);
      
      setConfigName(data[0].headerconfig_name);
      setDescription(data[0].headerconfig_description);
      setDatabase({ value: "mysql", label: "Mysql" });
      setHeaderid(data[0].headerconfig_id);
      fetchDatabaseInfo();
      
      console.log("header config Response!!!", response);
      
      // Parse the JSON data - fixed field name
      let headerDetails = JSON.parse(data[0].header_details_json || data[0].header_details || '[]');
      // sort by saved index if available, otherwise keep original order
      headerDetails = headerDetails.slice().sort((a, b) => {
        const ai = a.index != null ? a.index : 0;
        const bi = b.index != null ? b.index : 0;
        return ai - bi;
      });
      
      setRows(headerDetails.map((detail, idx) => ({
        id: detail.id,
        index: detail.index != null ? detail.index : idx + 1,
        schema: detail.schema,
        table: detail.table,
        header: detail.header,
        function: detail.function,
        customOptions: detail.customOptions || {},
        headerOptions: detail.headerOptions || [],
        tableOptions1: detail.tableOptions1 || [],
        renameChecked: detail.renameChecked || false,
        renameValue: detail.renameValue || '',
        width: detail.width || { "label": "Medium", "value": "m" },
        isMandatory: detail.isMandatory || false
      })));
    } catch (error) {
      console.error("Error in database request:", error);
      showErrorMessage("Error fetching edit information");
    }
  };

  const handleAddRow = () => {
    const lastRow = rows[rows.length - 1];
    const newId = lastRow ? lastRow.id + 1 : 1;

    setRows([...rows, {
      id: newId,
      index: rows.length + 1,
      schema: null,
      table: null,
      header: null,
      function: null,
      customOptions: {},
      headerOptions: [],
      tableOptions1: [],
      renameChecked: false,
      renameValue: '',
      width: null,
      isMandatory: false
    }]);
  };

  const handleSelectChange123 = (index, field, selectedOption) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = selectedOption;
    
    console.log('field', field);
    
    if (field === 'schema') {
      fetchTableData(selectedOption);
      setSelectedSchema(selectedOption);
    } else if (field === 'table') {
      fetchHeaderData(selectedOption);
    }
    
    setRows(updatedRows);
  };

  // Effects
  useEffect(() => {
    fetchFunctionOptions();
    fetchAllHeaderConfigs();
    fetchTableInfo();
  }, [filterconditions]); // Added filterconditions as dependency

  return (
    <>
      {successMessage && (
        <Message positive>
          <Message.Header>Success</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}
      
      {errorMessage && (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <div style={{ width: '100%' }}>
          <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab" }}>HEADER CONFIG</h2>
        </div>
      </Grid>

      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
          <Grid.Column>
            <div className="form-group">
              <label className="label1 mb-1" htmlFor={`configNameInput`}>Config Name</label>
              <div>
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="Relationship name"
                  value={configName}
                  onChange={(e) => setConfigName(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="form-group">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label>
              <div>
                <Input
                  type="text"
                  className="resource_input"
                  style={{ width: '12em' }}
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="form-group">
              <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Database</label>
              <Select
                clearable
                options={DATABASE_OPTIONS}
                selection
                className="resource_input"
                size='mini'
                value={database}
                onChange={handleSelectChange}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid divided style={{ backgroundColor: "#fff", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="rows-list">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{
                  backgroundColor: snapshot.isDraggingOver ? '#f0f0f0' : 'transparent',
                  ...provided.droppableProps.style
                }}
              >
                {rows.map((row, index) => (
                  <Draggable key={row.id} draggableId={`row-${row.id}`} index={index}>
                    {(provided2, snapshot2) => (
                      <div
                        ref={provided2.innerRef}
                        {...provided2.draggableProps}
                        {...provided2.dragHandleProps}
                        style={{
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          padding: '10px',
                          marginBottom: '10px',
                          backgroundColor: snapshot2.isDragging ? '#e8f4f8' : '#f9f9f9',
                          ...provided2.draggableProps.style
                        }}
                      >
              <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {/* order/index control */}
                <div className="col" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <label className="label1 mb-1" htmlFor={`orderInput`}>Order</label>
                  <Input
                    type="number"
                    min="1"
                    value={row.index || index + 1}
                    onChange={(e) => handleIndexChange(index, e.target.value)}
                    style={{ width: '60px' }}
                  />
                  <Button icon="arrow up" size="mini" compact onClick={() => moveRow(index, index - 1)} disabled={index === 0} />
                  <Button icon="arrow down" size="mini" compact onClick={() => moveRow(index, index + 1)} disabled={index === rows.length - 1} />
                </div>
                <div className="col">
                  <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Schema</label>
                  <Select
                    options={databaseNames}
                    value={row.schema}
                    onChange={(selectedOption) => handleSelectChange123(index, 'schema', selectedOption)}
                    placeholder="Select Schema"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '150px',
                        flexWrap: 'nowrap',
                      })
                    }}
                  />
                </div>

                <div className="col">
                  <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Table</label>
                  <Select
                    options={tableNames}
                    value={row.table}
                    onChange={(selectedOption) => handleSelectChange123(index, 'table', selectedOption)}
                    placeholder="Select Table"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '150px',
                        flexWrap: 'nowrap',
                      })
                    }}
                  />
                </div>

                <div className="col">
                  <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Header</label>
                  <Select
                    options={headerNames}
                    value={row.header}
                    onChange={(selectedOption) => handleSelectChange123(index, 'header', selectedOption)}
                    placeholder="Select Header"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '150px',
                        flexWrap: 'nowrap',
                      })
                    }}
                  />
                </div>

                <div className="col">
                  <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Purpose</label>
                  <Select
                    options={functionNames}
                    value={row.function}
                    onChange={(selectedOption) => handleSelectChange123(index, 'function', selectedOption)}
                    placeholder="Select Function"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '150px',
                        flexWrap: 'nowrap',
                      })
                    }}
                  />
                </div>

                {row.function && (
                  <div className="col" style={{ display: "flex", gap: "10px", alignItems: "center" }}>

                    {row.function.value === "Input Field" && (
                      <>
                        <Select
                          options={INPUT_FIELD_OPTIONS}
                          value={row.customOptions?.inputFieldDropdown || null}
                          onChange={(selectedOption) => handleCustomOptionChange(index, "inputFieldDropdown", selectedOption)}
                          placeholder="Select an option"
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: '300px',
                            }),
                          }}
                        />
                        {row.customOptions?.inputFieldDropdown?.value === "text" && (
                          <Input
                            type="number"
                            placeholder="Max number of digits"
                            value={row.customOptions?.maxDigits || ""}
                            onChange={(e) => handleCustomOptionChange(index, "maxDigits", e.target.value)}
                          />
                        )}
                        {row.customOptions?.inputFieldDropdown?.value === "decimal" && (
                          <Input
                            type="number"
                            placeholder="Max number of decimal places"
                            value={row.customOptions?.maxDecimalPlaces || ""}
                            onChange={(e) => handleCustomOptionChange(index, "maxDecimalPlaces", e.target.value)}
                          />
                        )}
                        {row.customOptions?.inputFieldDropdown?.value === "date" && (
                          <Select
                            options={DATE_FORMAT_OPTIONS}
                            value={row.customOptions?.inputFieldDropdown1 || null}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "inputFieldDropdown1", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        )}
                        {row.customOptions?.inputFieldDropdown?.value === "integer" && (
                          <Input
                            type="number"
                            placeholder="Max integer value"
                            value={row.customOptions?.maxInteger || ""}
                            onChange={(e) => handleCustomOptionChange(index, "maxInteger", e.target.value)}
                          />
                        )}
                      </>
                    )}

                    {(row.function.value === "Dropdown" || row.function.value === "Dropdown with Multiselect") && (
                      <>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Schema</label>
                          <Select
                            options={databaseNames}
                            value={row.customOptions?.inputFieldDropdown || null}
                            onChange={(selectedOption) => {
                              handleCustomOptionChange(index, "inputFieldDropdown", selectedOption);
                              fetchTableData1(selectedOption, index);
                            }}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Table</label>
                          <Select
                            options={row.tableOptions1 || []}
                            value={row.customOptions?.inputFieldDropdown1 || null}
                            onChange={(selectedOption) => {
                              handleCustomOptionChange(index, "inputFieldDropdown1", selectedOption);
                              fetchHeaderData1(selectedOption, row.customOptions?.inputFieldDropdown || null, index);
                            }}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Header</label>
                          <Select
                            options={row.headerOptions || []}
                            value={row.customOptions?.inputFieldDropdown2 || null}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "inputFieldDropdown2", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Filter Conditions</label>
                          <Select
                            options={row.headerOptions || []}
                            value={row.customOptions?.filterconditions || null}
                            isMulti={true}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "filterconditions", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                      </>
                    )}

                    {row.function.value === "Data Displayer with reference" && (
                      <>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Schema</label>
                          <Select
                            options={databaseNames}
                            value={row.customOptions?.inputFieldDropdown || null}
                            onChange={(selectedOption) => {
                              handleCustomOptionChange(index, "inputFieldDropdown", selectedOption);
                              fetchTableData1(selectedOption, index);
                            }}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Table</label>
                          <Select
                            options={row.tableOptions1 || []}
                            value={row.customOptions?.inputFieldDropdown1 || null}
                            onChange={(selectedOption) => {
                              handleCustomOptionChange(index, "inputFieldDropdown1", selectedOption);
                              fetchHeaderData1(selectedOption, row.customOptions?.inputFieldDropdown || null, index);
                            }}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Reference Header</label>
                          <Select
                            options={row.headerOptions || []}
                            value={row.customOptions?.inputFieldDropdown2 || null}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "inputFieldDropdown2", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Fetch Field</label>
                          <Select
                            options={row.headerOptions || []}
                            value={row.customOptions?.fetchfield || null}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "fetchfield", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                        <div>
                          <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Filter Conditions</label>
                          <Select
                            options={row.headerOptions || []}
                            value={row.customOptions?.filterconditions || null}
                            isMulti={true}
                            onChange={(selectedOption) => handleCustomOptionChange(index, "filterconditions", selectedOption)}
                            placeholder="Select an option"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: '150px',
                              }),
                            }}
                          />
                        </div>
                      </>
                    )}

                    {row.function.value === "Date Field" && (
                      <div>
                        <label
                          className="label1 mb-1"
                          htmlFor="fileDownloadPath"
                          style={{ display: "block", marginBottom: "0.5rem" }}
                        >
                          Date Type
                        </label>
                        <Select
                          options={DATE_TYPE_OPTIONS}
                          value={row.customOptions?.inputFieldDropdown || null}
                          onChange={(selectedOption) => handleCustomOptionChange(index, "inputFieldDropdown", selectedOption)}
                          placeholder="Select an option"
                        />
                      </div>
                    )}

                    {row.function.value === "File Upload" && (
                      <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
                        <div>
                          <label
                            className="label1 mb-1"
                            htmlFor="fileUploadPath"
                            style={{ display: "block", marginBottom: "0.5rem" }}
                          >
                            File Upload Path
                          </label>
                          <Input
                            type="text"
                            id="fileUploadPath"
                            placeholder="File path"
                            value={row.customOptions?.filePath || ""}
                            onChange={(e) => handleCustomOptionChange(index, "filePath", e.target.value)}
                          />
                        </div>
                        <div>
                          <label
                            className="label1 mb-1"
                            htmlFor="fileDownloadPath"
                            style={{ display: "block", marginBottom: "0.5rem" }}
                          >
                            File Download Path
                          </label>
                          <Input
                            type="text"
                            id="fileDownloadPath"
                            placeholder="File path"
                            value={row.customOptions?.fileDownloadPath || ""}
                            onChange={(e) => handleCustomOptionChange(index, "fileDownloadPath", e.target.value)}
                          />
                        </div>
                      </div>
                    )}

                    {row.function.value === "File Displayer" && (
                      <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
                        <div>
                          <label
                            className="label1 mb-1"
                            htmlFor="fileDownloadPath"
                            style={{ display: "block", marginBottom: "0.5rem" }}
                          >
                            File Download Path
                          </label>
                          <Input
                            type="text"
                            id="fileDownloadPath"
                            placeholder="File path"
                            value={row.customOptions?.fileDownloadPath || ""}
                            onChange={(e) => handleCustomOptionChange(index, "fileDownloadPath", e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="col">
                  <label className="label1 mb-1" htmlFor={`relationshipTypeInput`}>Column Width</label>
                  <Select
                    options={WIDTH_OPTIONS}
                    value={row.width}
                    onChange={(selectedOption) => handleSelectChange123(index, 'width', selectedOption)}
                    placeholder="Select Function"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: '150px',
                        flexWrap: 'nowrap',
                      })
                    }}
                  />
                </div>

                {/* Mandatory checkbox - only show for Input Field and Dropdown types */}
                {row.function && (
                  row.function.value === "Input Field" || 
                  row.function.value === "Dropdown" || 
                  row.function.value === "Dropdown with Multiselect" ||
                  row.function.value === "Date Field" 
                ) && (
                  <div className="col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px', marginTop: '20px' }}>
                    <Checkbox
                      label="Mandatory"
                      checked={row.isMandatory || false}
                      onChange={(e, { checked }) => {
                        const updatedRows = [...rows];
                        updatedRows[index].isMandatory = checked;
                        setRows(updatedRows);
                      }}
                    />
                  </div>
                )}

                <div className="col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                  <Checkbox
                    label="Rename"
                    checked={row.renameChecked || false}
                    onChange={(e, { checked }) => {
                      const updatedRows = [...rows];
                      updatedRows[index].renameChecked = checked;
                      setRows(updatedRows);
                    }}
                  />
                  {row.renameChecked && (
                    <Button size="mini" onClick={() => handleOpenRenamePopup(index)}>
                      Rename
                    </Button>
                  )}
                </div>

                <Icon
                  name="trash"
                  style={{
                    cursor: "pointer",
                    marginLeft: "10px",
                    marginTop: "30px",
                    color: "red",
                  }}
                  onClick={() => handleDeleteRow(index)}
                />
              </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <button onClick={handleAddRow}>+</button>
      </Grid>

      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      </Grid>

      <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
          <Grid.Column>
            <button
              style={{
                height: "35px",
                width: "92px",
                backgroundColor: "#000055",
                color: "#ffffff",
                marginLeft: '2em'
              }}
              onClick={handleSubmit}
              disabled={isSaving}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
          </Grid.Column>
        </Grid.Row>

        <div
          className="ag-theme-alpine"
          style={{
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: '10px',
            width: `${columnDefs.length * 200}px`,
            maxWidth: '100%',
            maxHeight: '300px',
            height: '400px',
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            style={{ width: '100%' }}
            filter={true}
            animateRows={true}
          />
        </div>
      </Grid>

      <Modal show={renamePopupOpen} onHide={() => setRenamePopupOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Rename Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            fluid
            placeholder="Enter new field name"
            value={tempRenameValue}
            onChange={(e) => setTempRenameValue(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setRenamePopupOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const updatedRows = [...rows];
              updatedRows[currentRenameIndex].renameValue = tempRenameValue;
              setRows(updatedRows);
              setRenamePopupOpen(false);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Headerconfig;